import { call } from "redux-saga/effects";
import { API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* createUser(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USERS_MANAGEMENT.CREATE_USER, action.payload, true);
}

export function* uploadProfilePhoto(action: any): any {
  const { userId } = action.payload;
  const apiUrl = `${API_URL.USERS_MANAGEMENT.UPLOAD_PROFILE_PHOTO}${userId}`;
  yield call(sagaFunction, action, CallApi.POST, apiUrl, action.payload, true);
}

export function* getUsers(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.USERS_MANAGEMENT.GET_USERS, action.payload, true);
}

export function* updateUser(action: any): any {
  const { userId } = action.payload;
  const apiUrl = `${API_URL.USERS_MANAGEMENT.UPDATE_USER}${userId}`;
  yield call(sagaFunction, action, CallApi.PUT, apiUrl, action.payload, true);
}

export function* getUser(action: any): any {
  const { userId } = action.payload;
  const apiUrl = `${API_URL.USERS_MANAGEMENT.GET_USER}${userId}`;
  yield call(sagaFunction, action, CallApi.GET, apiUrl, null, true);
}

export function* deleteUser(action: any): any {
  const { userId } = action.payload;
  const apiUrl = `${API_URL.USERS_MANAGEMENT.DELETE_USER}${userId}`;
  yield call(sagaFunction, action, CallApi.DELETE, apiUrl, null, true);
}

export function* resendWelcomeEmail(action: any): any {
  const { userId } = action.payload;
  const apiUrl = `${API_URL.USERS_MANAGEMENT.RESEND_WELCOME_EMAIL(userId)}`;
  yield call(sagaFunction, action, CallApi.POST, apiUrl, null, true);
}

export function* updateRolePermissions(action: any): any {
  const { userId } = action.payload;
  const apiUrl = `${API_URL.USERS_MANAGEMENT.UPDATE_ROLE_PERMISSIONS(userId)}`;
  yield call(sagaFunction, action, CallApi.PUT, apiUrl, action.payload, true);
}

export function* getUserPermissions(action: any): any {
  const { userId } = action.payload;
  const apiUrl = `${API_URL.USERS_MANAGEMENT.GET_USER_PERMISSIONS(userId)}`;
  yield call(sagaFunction, action, CallApi.GET, apiUrl, null, true);
}

export function* inviteUser(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.USERS_MANAGEMENT.INVITE_USER, action.payload, true);
}
